import { BirdviewChartCatalogEmpty } from '../BirdviewChartCatalogEmpty'
import { BirdviewChartCatalogGroup } from '../BirdviewChartCatalogGroup'

import * as styles from './BirdviewChartCatalogList.module.css'

function BirdviewChartCatalogList({ groups, search, onToggle }) {
  return (
    <div className={styles.list}>
      {groups.length > 0 ? (
        groups.map(group => (
          <BirdviewChartCatalogGroup
            group={group}
            key={group.value}
            onToggle={onToggle}
          />
        ))
      ) : (
        <BirdviewChartCatalogEmpty search={search} />
      )}
    </div>
  )
}

export default BirdviewChartCatalogList
